/**
 * SundaeOS Chart Color Palette
 *
 * Vibrant, modern colors for all charts and data visualizations.
 * Based on the SundaeOS brand with Navy as the primary color.
 */

export const CHART_COLORS = {
  // Primary brand (from logo gradient)
  navy: '#021a4a',
  navyLight: '#1e3a6b',
  blue: '#5271A5',           // Mittelblau - from sidebar hover

  // Brand gradient colors
  purple: '#7c3aed',        // Vibrant purple - bridge between navy and pink
  pink: '#ec4899',          // Pink - from logo gradient

  // Accent colors
  yellow: '#fbbf24',        // Warm yellow - attention, highlight

  // Semantic
  success: '#10b981',       // Green for success states
  danger: '#ef4444',        // Red for errors

  // Neutral
  slate: '#64748b',
  slateLight: '#94a3b8',
  gray: '#6b7280',

  // Background
  backgroundLight: '#f1f5f9',
} as const;

/**
 * Semantic color mappings for common chart scenarios
 */
export const CHART_SEMANTIC = {
  // Funnel / Pipeline
  accepted: CHART_COLORS.success,
  sent: CHART_COLORS.purple,        // Lila
  draft: CHART_COLORS.navy,         // Navy für Draft
  rejected: CHART_COLORS.pink,      // Pink statt rot
  expired: CHART_COLORS.yellow,

  // Financial
  invoiced: CHART_COLORS.blue,
  paid: CHART_COLORS.success,
  open: CHART_COLORS.yellow,
  overdue: CHART_COLORS.danger,

  // Status
  active: CHART_COLORS.success,
  inactive: CHART_COLORS.slate,
  pending: CHART_COLORS.yellow,

  // Lifecycle stages
  lead: CHART_COLORS.slate,
  prospect: CHART_COLORS.blue,
  customer: CHART_COLORS.pink,
} as const;

/**
 * Array of colors for multi-series charts (in order of preference)
 */
export const CHART_SERIES_COLORS = [
  CHART_COLORS.navy,
  CHART_COLORS.blue,
  CHART_COLORS.purple,
  CHART_COLORS.pink,
  CHART_COLORS.yellow,
  CHART_COLORS.slate,
] as const;

/**
 * Get a color with opacity
 */
export function withOpacity(hexColor: string, opacity: number): string {
  const alpha = Math.round(opacity * 255).toString(16).padStart(2, '0');
  return `${hexColor}${alpha}`;
}
